export default () => ({
    open: false,
    mobile: window.matchMedia('only screen and (max-width: 760px)').matches,
    toggleOpen() {
        console.log(this.open);
        
        if(this.open) {
            this.open = false;
        } else {
            this.$dispatch('close');
            this.open = true;
        }
    },
    updateImage() {
        if(!this.mobile) {
            // console.log()
            console.log(this.$refs.rollimage.classList)
            document.querySelector('.centered img').src = this.$el.dataset.rollover;
            document.querySelector('.centered').classList.add('in');
        }
    },
    get class() {
        return this.open ? 'open' : ''
    }
})